import { defineMessages } from 'react-intl';

export default defineMessages({
  delegationDateLabel: {
    description: 'Label for the date a shipment was delegated to their fulfillment provider',
    defaultMessage: 'Delegation Date',
    id: 'wPxuLG',
  },
  deliveryLabel: {
    description: 'Label for the delivery date and/or time of a shipment',
    defaultMessage: 'Delivery',
    id: 'wlj9yF',
  },
  shipDateLabel: {
    description: 'Label for the date a shipment was shipped',
    defaultMessage: 'Ship Date',
    id: 'WYFFmK',
  },
  cost: {
    defaultMessage: 'Cost',
    description: 'The cost of the shipping label for a shipment',
    id: 'rv0Gx6',
  },
  amazonShippingNote: {
    description: 'Note for Amazon Shipping service that tells user that a scheduled pickup is required',
    defaultMessage: '*Amazon Shipping requires a <link>scheduled pickup</link> with an associated fee.',
    id: 'Qflyzr',
  },
});
